import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { config } from "@/lib/config";
import "./LegalPages.css";

export function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page not found · {config.appName}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <article className="legal-page legal-page--compact">
        <h1 className="legal-page__title">Page not found</h1>
        <p className="legal-page__meta">The URL may be incorrect or the page was removed.</p>
        <p>
          <Link to="/">Return to menu</Link>
        </p>
      </article>
    </>
  );
}
